import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import GearStocksCell from "./GearStocksCell";
import { FETCH_GEAR_STOCKS } from "./graphql";
import PricesCell from "./PricesCell";

const GearListTableView = ({ gears }) => {
  const productIds = gears.map((g) => g.id);
  const { loading, error, data } = useQuery(FETCH_GEAR_STOCKS, {
    variables: { productIds },
    fetchPolicy: "network-only",
  });

  function getStock(gear) {
    if (loading || error) return null;
    const res = data.gearStocks.find((s) => s.productId === gear.id);
    return res.stocks;
  }

  return (
    <table>
      <thead>
        <tr className=" sticky top-0 backdrop-blur bg-gray-100 bg-opacity-50 z-20">
          <th className="px-4">Item</th>
          <th>Supplier</th>
          <th className="text-right">MOQ</th>
          <th className="text-right">Leadtime(days)</th>
          <th className="text-right">Prices</th>
          <th className="text-right px-4">
            {loading
              ? "Loading stock..."
              : error
                ? "Error loading stock"
                : "Inventory"}
          </th>
        </tr>
      </thead>
      <tbody>
        {gears.map((gear) => (
          <tr
            key={gear.id}
            className="border-y border-gray-100 dark:border-r-gray-700"
          >
            <td className="px-4 py-4">
              <div
                className={`flex space-x-3
                  ${gear.description ? "items-start" : "items-center"}`}
              >
                {gear.image ? (
                  <img
                    className="w-12 rounded-2xl overflow-auto"
                    src={gear.image.thumb}
                  />
                ) : (
                  <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-2xl"></div>
                )}

                <div className="py-1">
                  <Link to={`${gear.id}`}>{gear.name}</Link>
                  {gear.description && (
                    <div className="opacity-70 whitespace-pre-wrap text-xs mt-1">
                      {gear.description}
                    </div>
                  )}
                </div>
              </div>
            </td>
            <td>{gear.supplierName}</td>
            <td className="text-right">{gear.moq}</td>
            <td className="text-right">{gear.leadtime}</td>
            <td className="text-right">
              <PricesCell currency={gear.currency} prices={gear.prices} />
            </td>
            <td className="px-4 text-right">
              <GearStocksCell stocks={getStock(gear)} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default GearListTableView;
